import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

import { HttpRequestService } from "app/auth/service/http-request.service";
import { AuthenticationService } from "./authentication.service";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class CustomerService {
  private url = `${environment.apiUrl}/private/companies`;

  constructor(
    private _httpService: HttpRequestService,
    private _auth: AuthenticationService,
    private _http: HttpClient,
    private _toastrService: ToastrService
  ) {}

  createOwner = (data): Observable<any> =>
    this._http
      .post(`${this.url}/create-and-config-owner`, data)
      .pipe(
        map((res) => {
          this._toastrService.success(
            "Cliente propietario ha sido creado correctamente"
          );
          return res;
        })
      )
      .pipe(
        catchError((error: any) => {
          const errorName = error.cause;
          console.error("Error al crear propietario", error);
          if (errorName === "company_name_already_exists") {
            this._toastrService.error(
              "Ya existe un cliente con el mismo nombre"
            );
          } else
            this._toastrService.error(
              "Ocurrio un error al agregar propietario"
            );
          throw error;
        })
      );

  createCompany = (data): Observable<any> =>
    this._http
      .post(`${this.url}/create-and-config-company`, data)
      .pipe(
        map((res) => {
          this._toastrService.success("Cliente creado correctamente");
          return res;
        })
      )
      .pipe(
        catchError((error: any) => {
          console.error("Error al crear Cliente", error);
          const errorName = error.cause;
          if (errorName === "company_name_already_exists") {
            this._toastrService.error(
              "Ya existe un cliente con el mismo nombre"
            );
          } else
            this._toastrService.error("Ocurrio un error al agregar Cliente");
          throw error;
        })
      );

  updateCompany = (companyId: string, data): Observable<any> =>
    this._http
      .put(`${this.url}/update-company/${companyId}`, data)
      .pipe(
        map((res) => {
          this._toastrService.success("Informacion actualizada correctamente");
        })
      )
      .pipe(
        catchError((error: any) => {
          const errorName = error.cause;
          console.error("Update company catch error", error);
          if (errorName === "company_name_already_exists") {
            this._toastrService.error(
              "Ya existe un cliente con el mismo nombre"
            );
          } else
            this._toastrService.error("Ocurrio un error al actualizar Cliente");
          throw error;
        })
      );

  approveEMGAccount = (companyId: number): Observable<any> =>
    this._http.put(`${this.url}/approve-emg-account/${companyId}`, {}).pipe(
      catchError((error: any) => {
        this._toastrService.error(
          "Ocurrio un error aprobar cuenta EMG del cliente"
        );
        console.error("Approve EMG account catch error", error);
        throw error;
      })
    );

  requestEmgAccount = (companyId: number): Observable<any> =>
    this._http.put(`${this.url}/request-emg-account/${companyId}`, {}).pipe(
      catchError((error: any) => {
        this._toastrService.error(
          "Ocurrio un error solicitar la distincion de costos"
        );
        console.error("request EMG account catch error", error);
        throw error;
      })
    );

  lockUnlockCompany = (companyId: number): Observable<any> =>
    this._http.put(`${this.url}/lock-unlock/${companyId}`, {}).pipe(
      catchError((error: any) => {
        this._toastrService.error(
          "Ocurrio un error bloquear/desbloquear cliente"
        );
        console.error("Lock Unlock company catch error", error);
        throw error;
      })
    );

  updateOwner = (companyId: string, data): Observable<any> =>
    this._http
      .put(`${this.url}/update-owner/${companyId}`, data)
      .pipe(
        map((res) => {
          this._toastrService.success("Informacion actualizada correctamente");
        })
      )
      .pipe(
        catchError((error: any) => {
          const errorName = error.cause;
          if (errorName === "company_name_already_exists") {
            this._toastrService.error(
              "Ya existe un Propietario o Cliente con el mismo nombre"
            );
          } else
            this._toastrService.error(
              "Ocurrio un error al agregar propietario"
            );
          console.error("Update owner catch error", error);
          throw error;
        })
      );

  aproveWhatsappAccount = (companyId: number): Observable<any> =>
    this._http.put(`${this.url}/approve-whatsapp-account/${companyId}`, {});

  // * INIT SAML2
  createSaml2Config = (data: {
    host: string;
    companyId: number;
    cert: string;
    callbackUrl: string;
    entryPoint: string;
  }): Observable<any> =>
    this._http
      .post(`${this.url}/create-saml2-config`, {
        ...data,
      })
      .pipe(
        map((res) => {
          this._toastrService.success(
            "Configuracion SAML2 creada correctamente"
          );
          return res;
        })
      )
      .pipe(
        catchError((error: any) => {
          console.error("Error al crear configuracion SAML2", error);
          this._toastrService.error(
            "Ocurrio un error al crear configuracion SAML2"
          );
          throw error;
        })
      );

  // * END SAML2

  // todo
  updateCompanyTheme = (data, companyId: string): Observable<any> =>
    this._http.put(`${this.url}/update-company-theme/${companyId}`, data);

  getCustomerWithFilters = (filters = {}): Observable<any> =>
    this._http.get(`${this.url}/list-with-filters`, { params: filters });

  getOwners = (): Observable<any> => this._http.get(`${this.url}/list-owners`);

  getSimpleOwners = (): Observable<any> => this._http.get(`${this.url}/owners`);
  getSimpleCompanies = (): Observable<any> =>
    this._http.get(`${this.url}/companies`);

  getCustomerFullDataById = (companyId: string): Observable<any> =>
    this._http.get(`${this.url}/get-full-by-id/${companyId}`);

  getAll = (): Observable<any> =>
    this._http.get(`${this.url}/list-with-filters`);

  getCompanies = (): Observable<any> =>
    this._http.get(`${this.url}/list-company`);

  getCompanyById = (companyId: number): Observable<any> =>
    this._http.get(`${this.url}/${companyId}`);

  getCompanySubscription = (): Observable<any> =>
    this._http.get(`${this.url}/subscription`);

  hasEmgApproved = (): Observable<any> =>
    this._http.get(`${this.url}/has-emg-approved/${this.companyId}`);

  getCompanySubscriptionSummary = (): Observable<any> =>
    this._http.get(`${this.url}/company-subscription-summary`);

  getCompanyCountries = (companyId: string) =>
    this._http.get(`${this.url}/company-countries/${companyId}`);

  getCompany(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpService
        .Customer(this.companyId, this.companyId)
        .get()
        .subscribe(
          (response: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  validateCustomer(name): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpService
        .ValidateCustomer(this.companyId, name)
        .get()
        .subscribe(
          (response: any) => resolve(response),
          (err) => reject(err)
        );
    });
  }

  updateId(conf): Promise<any> {
    conf.updated_by = this.userId;
    return new Promise((resolve, reject) => {
      this._httpService
        .Customer(this.companyId, this.companyId)
        .put(conf)
        .subscribe(
          (response: any) => resolve(response),
          (err) => reject(err)
        );
    });
  }

  getCompaniesByPlan(planId: number): Observable<any> {
    return this._http.get(`${this.url}/list-by-plan/${planId}`);
  }

  get companyId() {
    return this._auth.companyId;
  }

  get userId() {
    return this._auth.userId;
  }
}
